import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-service-elec-gaz',
  templateUrl: './service-elec-gaz.component.html',
  styleUrls: ['./service-elec-gaz.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServiceElecGazComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {}
  toOrdering() {
    this.router.navigate(['/']);
  }
}
